import {useMutation} from '@tanstack/react-query';
import TournamentRestClient from '@/Api/TournamentRestClient';
import {formatPlayerDisplay} from '@/Utils/CommonUtils';

export default function useGetTournamentPairings(
  handleOnSuccess?: (data: any) => void,
  handleOnError?: (error: any) => void,
) {
  const mutation = useMutation(
    async ({
      tournamentId,
      round,
      limit,
      offset,
      search,
      ongoing,
      userId,
    }: {
      tournamentId: string;
      round: number;
      limit: number;
      offset: number;
      search?: string;
      ongoing?: boolean;
      userId?: string | null;
    }) => {
      const params = new URLSearchParams({
        tournamentId,
        round: round.toString(),
        limit: limit.toString(),
        offset: offset.toString(),
      });

      if (search?.trim()) {
        params.append('search', search.trim());
      }

      if (ongoing !== undefined) {
        params.append('ongoing', ongoing.toString());
      }

      if (userId) {
        params.append('userId', userId.toString());
      }

      const response = await TournamentRestClient.get(
        `/tournament/get-pairings?${params.toString()}`,
      );
      if (response?.data?.data && Array.isArray(response.data.data)) {
        response.data.data = response?.data?.data?.map(item => {
          const formatted = {...item};
          if (item?.player) {
            formatted.player = formatPlayerDisplay(item?.player);
          }
          if (item?.opponent) {
            formatted.opponent = formatPlayerDisplay(item?.opponent);
          }
          return formatted;
        });
      }
      return response?.data;
    },
    {
      onSuccess: data => {
        if (handleOnSuccess) handleOnSuccess(data);
      },
      onError: error => {
        if (handleOnError) handleOnError(error);
      },
    },
  );

  return mutation;
}
